import React from 'react'
import ViewUpdate from './ViewUpdate'
import SectionBoxContainer from '../../components/SectionBoxContainer'

export default function LatestUpdate() {
    return(
        <div className="latest-update">
            <SectionBoxContainer
                showTitle
                title="Latest Updates"
            >
                <ViewUpdate id={0} latest />
            </SectionBoxContainer>
        </div>
    )
}